import React, { useEffect, useState } from 'react'
import './About.css'
import projectDetails from '../../projectDetails.json'
import { getDocs } from "firebase/firestore"; 
import { skillRef } from '../../Firebase/collections';

function About() {
    const [age, setAge] = useState()
    const [skills, setSkills] = useState([])
    useEffect(() => {
        const DateOfBOD = new Date(2001, 3, 15)
        const currentDate = new Date()
        setAge(currentDate.getFullYear() - DateOfBOD.getFullYear())
    }, [])

    useEffect(() => {
        getDocs(skillRef).then((snap) => {
            setSkills(snap.docs.map(doc => doc.data()))
        })
    })

    return (
        <div className='about'>
            <div className="pageTitle">
                <h3>/ about</h3>
                <div className='line-bar'></div>
            </div>
            <h1 className='title'>Learn more about me</h1>
            {/*--- Header ---*/}
            <div className="header">
                <h3>Developer & ceh student</h3>
                <p>I started developing various technical skill after completing 12th grade. I have gained the experience and confidence to contribute my talents to the industry!</p>

                <div className="list-box">
                    <div className="list-left">
                        <ul>
                            <li>
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                <span>DOB :</span>15/04/2001</li>
                            <li>
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                <span>Phone Number :</span>+9180 7898 0314</li>
                            <li>
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                <span>City :</span> Kannur, Kerala</li>
                        </ul>
                    </div>
                    <div className="list-right">
                        <ul>
                            <li>
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                <span>Age :</span>{age}</li>
                            <li>
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                <span>Degree :</span>BCA</li>
                            <li>
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                <span>Email :</span>muhammedhaby08@gmail.com</li>
                        </ul>
                    </div>
                </div>
            </div> {/*---End Header ---*/}

            {/*--- Skill Section ---*/}

            <div className="pageTitle">
                <h3>Skill</h3>
                <div className='line-bar'></div>
            </div>

            <div className="skill">
                {
                    skills.map(({name,range},index) => {
                        return(
                            <div className='skill-box' key={index}>
                                <h5>{name}</h5>
                                <div className="skill-progress">
                                    <div className="skill-innner-prograss" style={{ width: range }}>{range}</div>
                                </div>
                            </div>
                        )
                    })
                }
            </div> {/*--- End Skill ---*/}
            {/*-- Interest ---*/}
            <div className="pageTitle">
                <h3>Interests</h3>
                <div className='line-bar'></div>
            </div>

            <div className="interests">
                <div className="interest-box">
                    <i className="fa fa-globe" aria-hidden="true"></i>
                    <span>Web Development</span>
                </div>

                <div className="interest-box">
                    <i className="fa fa-code" aria-hidden="true"></i>
                    <span>Scripting</span>
                </div>

                <div className="interest-box">
                    <i className="fa fa-laptop" aria-hidden="true"></i>
                    <span>Application Development</span>
                </div>

                <div className="interest-box">
                    <i className="fa fa-microchip" aria-hidden="true"></i>
                    <span>IOT</span>
                </div>
            </div>

            {/*-- Major Projects ---*/}
            <div className="pageTitle">
                <h3>Major Projects</h3>
                <div className='line-bar'></div>
            </div>

            <div className="major-project">
                {
                    projectDetails.map((value, key) => {
                        return (
                            <div key={key} className="major-project-box">
                                <div className="major-project-box-left">
                                    <img src={value.image} alt="project_image" />
                                    <h2 className='title'>{value.title}</h2>
                                </div>
                                <div className="major-project-box-right">
                                    
                                    <i className="fa fa-info" aria-hidden="true"></i>
                                </div>
                            </div>
                        )
                    })
                }
            </div>{/* End Major Projects */}
        </div>
    )
}

export default About
